import store from '../front/store';

const title = process.env.MIX_TITLE;


export default [
  {
    path: '/mobile/payment',
    name: 'mobile-payment',
    component: () => import('./views/pages/Mobile/Payment'),
    meta: {
      layout: 'MobileLayout',
      title: title,
      profile: false,
    },
    beforeEnter(to, from, next) {
      store.commit('settings/setIsMobile', true);
      store.commit('shop/setSelectedPackage', null);

      if (to.hash !== '#b') {
        store.commit('shop/setVoucher', null);
      }

      next();
      return true;
    },
  }, {
    path: '/mobile/payment/:unit/:packageId',
    name: 'mobile-payment-method',
    component: () => import('#js_site/views/pages/MoreSettings/Payment'),
    meta: {
      layout: 'MobileLayout',
      title: title,
      profile: false,
    },
  },
  {
    path: '/mobile/payment-old',
    name: 'mobile-payment',
    component: () => import('./views/pages/Mobile/PaymentV1'),
    meta: {
      layout: 'MobileLayout',
      title: title,
      profile: false,
    },
    beforeEnter(to, from, next) {
      store.commit('settings/setIsMobile', true);

      next();
      return true;
    },
  },
  {
    path: '/more-settings/payment-old/:unit',
    name: 'payment-old',
    component: () => import('#js_site/views/pages/MoreSettings/PaymentV1'),
    meta: {
      layout: 'MoreSettingsLayout',
      title: title,
      profile: false,
    }
  },
];
